import React, { useEffect, useState, useContext } from 'react';
import { apiCharge } from '../../services/api';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import AuthContext from '../../contexts/auth';

import { errorAlert } from '../../components/Toast';
import ErrorBoundary from '../../components/ErrorBoundary';

import Table from './table';
import './style.css';
import 'semantic-ui-css/semantic.min.css';

function Dashboard(props) {
  const { user } = useContext(AuthContext);
  const host = window.location.host;
  const group = JSON.parse(sessionStorage.getItem('@portal-cliente/group'));
  const token = JSON.parse(sessionStorage.getItem('@portal-cliente/token'));
  const [contracts, setContracts] = useState(null);
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState([]);
  const [showNoticeModal, setShowNoticeModal] = useState(
    host === 'cliente.primaveras.com.br',
  );

  const handleCheckout = () => {
    return props.history.push({
      pathname: '/checkout',
      state: {
        selected,
        cnpj: contracts[tab].cnpj,
      },
    });
  };

  const handleGetCharges = async () => {
    try {
      const { data } = await apiCharge.get(`/v2/charges/${group}/${user.cpf}/list`, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      setContracts(data.contratos);
    } catch {
      errorAlert('Falha ao carregar titulos!');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetCharges();
  }, []);

  useEffect(() => {
    // hack para atualizar os "check" das linhas da tabela - gambiarra
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [tab]);

  return (
    <div
      className="tab-pane fade show active"
      id="vencimentos"
      role="tabpanel"
      aria-labelledby="vencimentos-tab"
    >
      <div className="container-fluid">
        <ul className="nav nav-tabs">
          {contracts &&
            contracts.map((item, index) => {
              return (
                <li
                  className="nav-item"
                  key={index}
                  style={{ cursor: 'pointer' }}
                >
                  <a
                    className={index === tab ? 'nav-link active' : 'nav-link'}
                    onClick={() => setTab(index)}
                  >
                    {item.tipo.toUpperCase() === 'FUNERARIA'
                      ? `PLANO - ${item.codigo}`
                      : `${item.tipo.toUpperCase()} - ${item.codigo}`}
                  </a>
                </li>
              );
            })}
        </ul>
        {/* `key={tab}` força remontar o boundary ao trocar de aba — sem
            isso, uma vez que um contrato dispara o fallback de erro, a
            mensagem fica presa mesmo trocando pra uma aba saudável. A nav
            acima fica fora do boundary pra continuar clicável se Table quebrar. */}
        <ErrorBoundary key={tab}>
          <Table
            tab={tab}
            loading={loading}
            contract={contracts ? contracts[tab] : null}
            onChange={handleCheckout}
            onSelected={setSelected}
          />
        </ErrorBoundary>
      </div>
      <Modal
        show={showNoticeModal}
        onHide={() => setShowNoticeModal(false)}
        centered
        dialogClassName="dashboard-notice-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="dashboard-notice-title">
            Comunicado Importante
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="dashboard-notice-body">
          <p>Prezado cliente Primaveras,</p>
          <p>
            Nesta Área do Cliente você poderá copiar o código de barras do
            boleto, caso ele já esteja registrado.
          </p>
          <p>
            Ao lado da aba situação, os boletos registrados terão uma imagem de
            cód. barras, basta clicar, copiar o código e realizar o pagamento
            diretamente pelo aplicativo ou banco de sua preferência.
          </p>
          <p>
            Seguimos trabalhando para oferecer mais agilidade, conforto e
            praticidade para você.
          </p>
          <p>Agradecemos pela confiança e parceria 💙</p>
          <p>Equipe Primaveras</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowNoticeModal(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Dashboard;
